module.exports = __webpack_public_path__ + "static/media/USSD.28a49340.svg";